var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h-full" },
    [
      _c(
        "transition",
        { attrs: { name: "fade-transform", mode: "out-in" } },
        [
          _c("common-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.viewMode === "list",
                expression: "pageData.viewMode==='list'",
              },
            ],
            ref: "table",
          }),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade-transform", mode: "out-in" } },
        [
          _c("common-form", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.viewMode === "info",
                expression: "pageData.viewMode==='info'",
              },
            ],
            ref: "form",
            on: { success: _vm.updateTable },
            scopedSlots: _vm._u(
              [
                {
                  key: "form-bottom",
                  fn: function () {
                    return [_vm._t("form-bottom")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }